import React, { useEffect, useState } from "react";
import "../../../../styles/generatejdAitext.css";

import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";

const fonts = [
  "Inter",
  "Arial",
  "Sans Serif",
  "Georgia",
  "Impact",
  "Courier New",
  "serif",
  "monospace",
  "cursive",
];

var Font = Quill.import("attributors/style/font");
Font.whitelist = fonts;
Quill.register(Font, true);

let toolbarOptions = [
  [{ font: Font.whitelist }],

  ["bold", "italic", "underline"], // toggled buttons
  // ["blockquote"],
  ["link"],

  [{ list: "ordered" }, { list: "bullet" }],
  [{ script: "sub" }, { script: "super" }], // superscript/subscript
  [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
  [{ color: [] }], // dropdown with defaults from theme

  [{ size: ["small", false, "large", "huge"] }], // custom dropdown
  [{ header: [1, 2, 3, 4, 5, 6, false] }],

  // [{ direction: "rtl" }], // text direction
  [{ align: [] }],

  ["clean"], // remove formatting button
];
function GenerateJdAiText({ generateAiText, setGenerateJDtext }) {
  const [message, setMessage] = useState("");

  useEffect(() => {
    //replace line breaks with <br> for react-quill
    const processedMessage = generateAiText.replace(/\n/g, "<br>");
    setMessage(processedMessage);
  }, [generateAiText]);
  const handleChange = (e) => {
    setGenerateJDtext(e);
    setMessage(e);
  };
  return (
    <div className="border">
      {" "}
      <div className="quill-box ">
        <ReactQuill
          theme="snow"
          value={message}
          onChange={(e) => handleChange(e)}
          //   style={{width:"400px" }}
          modules={{
            toolbar: toolbarOptions,
          }}
        />
      </div>
      {/* <Row className="buttons-container w-100 p-0 mb-3 mx-auto">
        <Col md className="mt-2 p-0 ">
          <Button
            // onClick={props.onHide}
            className=" bg-light p-2  "
            style={{
              color: "#344054",
              width: "100%",
              borderRadius: "8px",
              border: " 1px solid #D0D5DD",
              boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
            }}
          >
            cancel
          </Button>
        </Col>
        <Col md className="mt-2 p-0 ">
          <Button
            className=" p-2 fs-6"
            style={{
              color: "white",
              width: "100%",
              background: "#206DC5",
              borderRadius: "8px",
              border: "1px solid #A9CFFB",
              boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
            }}
            // onClick={apiCall}
          >
            Submit
          </Button>
        </Col>
      </Row> */}
    </div>
  );
}

export default GenerateJdAiText;
